import { Component, inject } from '@angular/core';
import { AuthService, BaseSiteService, CmsComponent, CmsNavigationNode, CmsService, WindowRef } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { GgNavigationItem } from '../../model/gg-navigation-item.model';
import { EnvironmentService } from '../../services/environment.service';

export interface GgFooterComponent {
  uid: string;
  notice: string;
  links: string;
  navigationNode: CmsNavigationNode;
  linkList: string;
}

export interface TrustPilot {
  baseSite: string;
  show: boolean;
  dataLocale: string;
  businessUnitId: string;
  templateId: string;
  url: string;
}

@Component({
  selector: 'app-gg-footer',
  templateUrl: 'gg-footer.component.html',
  styleUrls: ['gg-footer.component.scss'],
  standalone: false,
})
export class GgFooterComponent {
  data$: Observable<GgFooterComponent> = this.componentData.data$;
  logged$ = inject(AuthService).isUserLoggedIn();

  constructor(
    private componentData: CmsComponentData<GgFooterComponent>,
    private cmsService: CmsService,
    protected baseSiteService: BaseSiteService,
    protected environmentService: EnvironmentService,
    protected winRef: WindowRef
  ) {}

  links$: Observable<CmsComponent[]> = this.componentData.data$.pipe(
    switchMap((data) =>
      combineLatest(data.links.split(' ').map((link: string) => this.cmsService.getComponentData<CmsComponent>(link)))
    )
  );

  linkList$: Observable<GgNavigationItem[]> = this.componentData.data$.pipe(
    filter((data) => data.linkList !== undefined),
    switchMap((data) =>
      combineLatest(
        data.linkList.split(' ').map((link: string) => this.cmsService.getComponentData<GgNavigationItem>(link))
      )
    )
  );

  trustpilot$: Observable<TrustPilot> = this.baseSiteService
    .getActive()
    .pipe(
      map((baseSite) => ({ baseSite, ...this.environmentService.getCurrentEnvironment().eShop.trustPilot[baseSite] }))
    );
}
